export const linkedInProfileRegex = /^(https?:\/\/)?(www\.)?linkedin.com\/in\/([-a-zA-Z0-9]+)/

export const LINKEDIN_LOCALIZATION_KEY = 'builder.prefill_resume.create_resume_with_linkedin'
